import React from 'react';
import InvitationDialog from './InvitationDialog';
import LoginNoInvitationForm from './LoginNoInvitationForm';

const FormScene = () => (
  <div>
    <LoginNoInvitationForm />
    <InvitationDialog message="Our administrator will contact you soon" />
  </div>
);
export default FormScene;
